export default "__VITE_ASSET__bf843c66__"